<template>
  <BaseBadge :variant="variant">
    {{ text }}
  </BaseBadge>
</template>

<script lang="ts" setup>
import BaseBadge from '@/components/base/BaseBadge.vue'
import { ref, watch } from 'vue'

const props = defineProps({
  status: {
    type: String,//as PropType<'draft' | 'awaiting_acceptance' | 'accepted' | 'declined' | 'archived'>,
    required: true
  }
})

const variant = ref<'base' | 'primary' | 'accent' | 'success' | 'error'>('base')
const text = ref<string>('')

watch(()=>props.status, () => {

  switch (props.status) {
    case 'draft':
      variant.value = 'primary'
      text.value = 'Draft'
      break
    case 'awaiting_acceptance':
      variant.value = 'accent'
      text.value = 'Awaiting Acceptance'
      break
    case 'accepted':
      variant.value = 'success'
      text.value = 'Accepted'
      break
    case 'declined':
      variant.value = 'error'
      text.value = 'Declined'
      break
    case 'archived':
      text.value = 'Archived'
      variant.value = 'base'
      break
  }
}, { immediate: true })

</script>
